"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderTransactionsByOrderId = void 0;
const getOrderTransactionsByOrderId = async (supabase, id) => {
    const { data, error } = await supabase.rpc("get_transactions_by_order_id", {
        o_id: id,
    });
    if (!error)
        return data;
    return null;
};
exports.getOrderTransactionsByOrderId = getOrderTransactionsByOrderId;
